import React from "react"
import { FaEnvelope } from 'react-icons/fa'
import slack_logo from '../assets/slack-logo-slide.png'
import openscope_logo from '../assets/crop_openscope.png'
import github_logo from '../assets/github.png'
import "./Contact.css";

export default function Contact(){
    return (
        <main className="ContactDescription">
            <header className="support-page-heading">
                <p className="section-eyebrow">OpenScope / Community</p>
                <h2>Contact</h2>
            </header>
            <div className='ContactList'>
                <div className='ContactItem'>
                    <a href="https://join.slack.com/t/openscope-allen/shared_invite/zt-2aq82vmsz-_cw_~Fq4s~uxb8weWaxyiA">
                        <img src={slack_logo} alt="" />
                        <div><h3>Join the conversation</h3>
                            <p>Datasets, analysis, and collaborations with the OpenScope community.</p>
                            <span className="contact-destination">OpenScope Slack</span>
                        </div>
                    </a> 
                </div>
                <div className='ContactItem'>
                    <a href="mailto:openscope@alleninstitute.org">
                        <img src={openscope_logo} alt="" />
                        <div><h3>OpenScope program</h3>
                            <p>Questions about the program and research opportunities.</p>
                            <span className="contact-destination">openscope@alleninstitute.org</span>
                        </div>
                    </a>
                </div>
                <div className='ContactItem'>
                    <a href="mailto:carter.peene@alleninstitute.org">
                        <FaEnvelope size={40} aria-hidden="true" />
                        <div><h3>Data and technical support</h3>
                            <p>For questions about the OpenScope Data Portal and NWB files, contact Carter Peene.</p>
                            <span className="contact-destination">carter.peene@alleninstitute.org</span>
                        </div>
                    </a> 
                </div>
                <div className='ContactItem'>
                    <a href="https://github.com/AllenInstitute/openscope_databook">
                        <img src={github_logo} alt="" />
                        <div><h3>Contribute to the Databook</h3>
                            <p>Code, analysis, issues, and pull requests.</p>
                            <span className="contact-destination">OpenScope on GitHub</span>
                        </div>
                    </a> 
                </div>
            </div>
        </main>
    )
}